<template>
  <nav
    class="navbar navbar-expand navbar-light d-none d-md-flex px-6 ps-0"
    id="topbar"
  >
    <div class="container-fluid">
      <router-link :to="paths.home" class="d-flex align-items-center">
        <!-- TODO: o pro usa sidebar_logo.svg; falta um SVG do logo do paciente -->
        <img src="@/assets/img/navlogo.png" class="rounded me-2" alt="" />
        <!-- EXCLUSIVO DO MAIN: versão/ambiente ao lado do logo -->
        <VersionComponent />
      </router-link>

      <nav aria-label="breadcrumb" class="me-auto ms-4">
        <ol class="breadcrumb fw-bold">
          <router-link v-slot="{ navigate }" custom v-if="link" :to="link">
            <li
              @click="navigate"
              class="breadcrumb-item d-flex align-items-center cursor-pointer"
            >
              <a>
                {{ linkName }}
              </a>
            </li>
          </router-link>
          <router-link
            v-slot="{ navigate }"
            custom
            v-if="sublink"
            :to="sublink"
          >
            <li
              @click="navigate"
              class="breadcrumb-item d-flex align-items-center cursor-pointer"
            >
              <a>{{ sublinkName }}</a>
            </li>
          </router-link>
          <li
            class="breadcrumb-item active d-flex align-items-center"
            aria-current="page"
          >
            {{ current }}
          </li>
        </ol>
      </nav>

      <!-- EXCLUSIVO DO MAIN: o app do paciente tem páginas públicas -->
      <ul class="navbar-nav" v-if="!session">
        <router-link active-class="router-link-active" :to="paths.login">
          <li class="nav-item">
            <a class="nav-link text-paragraph btn btn-sm btn-white fw-bold"
              >Entrar</a
            >
          </li>
        </router-link>
      </ul>

      <div class="navbar-user" v-else>
        <ul class="navbar-nav">
          <!-- ordem da tab bar do app: Home, Sessões, Pamia, Chats, Mais; e Notificações no fim -->
          <template v-for="(link, index) in links" :key="link.title">
            <li
              v-if="link.navigate"
              class="nav-item cursor-pointer"
              @click="link.navigate()"
            >
              <a class="nav-link text-paragraph">{{ link.title }}</a>
            </li>
            <router-link
              v-else
              active-class="nav-route-matched"
              exact-active-class="nav-route-exact"
              :class="{
                'router-link-active': isNavLinkActive(route.path, link.to),
              }"
              :to="link.to"
            >
              <li class="nav-item">
                <a
                  class="nav-link text-paragraph d-flex align-items-center gap-2"
                >
                  <img
                    v-if="link.icon"
                    :src="
                      isNavLinkActive(route.path, link.to)
                        ? link.icon.active
                        : link.icon.inactive
                    "
                    alt=""
                    class="nav-tab-icon"
                  />{{ link.title }}
                </a>
              </li>
            </router-link>
            <!-- Pamia no lugar da aba do meio do app (no celular continua o botão flutuante) -->
            <li
              v-if="index === 1"
              class="nav-item cursor-pointer"
              id="navbar-pamia"
              @click="openPamia"
            >
              <a
                class="nav-link text-paragraph d-flex align-items-center gap-2"
              >
                <img
                  :src="pamiaIcon.inactive"
                  alt=""
                  class="nav-tab-icon"
                />Pamia
              </a>
            </li>
          </template>
          <li class="nav-item d-flex align-items-center">
            <NotificationBell id="navbar-notifications" label />
          </li>
        </ul>
        <span class="text-paragraph text-muted navbar-pipe">|</span>
        <!-- o avatar leva ao Mais (o Sair fica lá, com confirmação) -->
        <router-link
          :to="paths.more"
          class="d-flex align-items-center text-decoration-none text-primary"
          id="navbar-profile"
        >
          <span class="text-subtitle me-3">{{ displayName }}</span>
          <img
            v-if="session?.formatted_image"
            :src="session?.formatted_image"
            alt=""
            width="40"
            height="40"
            class="rounded-circle"
          />
          <i v-else class="fa-solid fa-user-circle display-3 text-muted"></i>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";
import paths from "@/router/paths";
import { getNavLinks, isNavLinkActive, tabIcon } from "./navLinks";
import NotificationBell from "@/components/app/NotificationBell.vue";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useRoute } from "vue-router";

defineProps<{
  link?: string;
  linkName?: string;
  sublink?: string;
  sublinkName?: string;
  current?: string;
}>();

const route = useRoute();
const { session } = storeToRefs(useSessionStore());
const openPamia = () => EventBus.$emit(EventBusNames.OPEN_PAMIA);
const pamiaIcon = tabIcon("pamia");
const displayName = computed(
  () => session.value?.nickname || session.value?.name?.split(" ")[0],
);

const links = getNavLinks(paths);
</script>

<style scoped>
/* ícones da tab bar do app, pequenos e à esquerda do texto */
/* mesmo espaço dos dois lados do pipe (o último item tem margem negativa do nav-link) */
.navbar-pipe {
  margin: 0 0.5rem 0 1rem;
}

.nav-tab-icon {
  height: 18px;
  width: auto;
}
</style>
